import { UPDATE_LOGO_REQUEST, UPDATE_LOGO_SUCCESS, UPDATE_LOGO_FAILURE } from '../constants/logoConstants';

const initialState = {
  uploading: false,
  error: null,
  response: null,
};

const logoReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LOGO_REQUEST:
      return {
        ...state,
        uploading: true,
        error: null,
        response: null,
      };
    case UPDATE_LOGO_SUCCESS:
      return {
        ...state,
        uploading: false,
        response: action.payload,
      };
    case UPDATE_LOGO_FAILURE:
      return {
        ...state,
        uploading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default logoReducer;